async function getLicenses(condition) {
  try {
    const resData = await window.axios.get('/api/v1/admin/license/all', { params: condition });
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function findLicenseById(id) {
  try {
    const resData = await window.axios.get('/api/v1/admin/license', { params: { id } });
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function updateLicense(params) {
  try {
    const resData = await window.axios.put('/api/v1/admin/license', params);
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function creatLicense(params) {
  try {
    const resData = await window.axios.post('/api/v1/admin/license', params);
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function getLicenseSetting() {
  const resData = await window.axios.get('/api/v1/admin/license/setting');
  return resData.data;
}
async function setLicenseSetting(setting) {
  const resData = await window.axios.put('/api/v1/admin/license/setting', setting);
  return resData.data;
}

module.exports = { getLicenses, findLicenseById, updateLicense, creatLicense, getLicenseSetting, setLicenseSetting };
